// extracted by mini-css-extract-plugin
export default {"submitSuccessful":"SubmitSuccessful_submitSuccessful__ZBjhK","submitSuccessfulPageWithText":"SubmitSuccessful_submitSuccessfulPageWithText__Tp2J3"};